import { client } from "../client/client";

export const getAllUsers = async (
  page,
  limit,
  fromDate,
  toDate,
  search,
  status,
  role
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (role) params.append("role", role);

    const response = await client.get(`/users?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getUser = async (userId) => {
  try {
    const response = await client.get(`/users/${userId}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await client.delete(`/users/${userId}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addAdminUser = async (
  email,
  username,
  firstName,
  lastName,
  phoneNumber,
  role,
  branch,
  profile_image
) => {
  try {
    const response = await client.post("/users", {
      email: email,
      username: username,
      firstname: firstName,
      lastname: lastName,
      phone: phoneNumber,
      status: "Active",
      country: "Kenya",
      role_id: role,
      branch_id: branch,
      profile_image: profile_image,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const editAdminUser = async (
  userId,
  email,
  username,
  firstName,
  lastName,
  phoneNumber,
  role,
  branch,
  profile_image
) => {
  try {
    const payload = {
      status: "Active",
      country: "Kenya",
      ...(email && { email }),
      ...(username && { username }),
      ...(firstName && { firstname: firstName }),
      ...(lastName && { lastname: lastName }),
      ...(phoneNumber && { phone: phoneNumber }),
      ...(role && { role_id: role }),
      ...(branch && { branch_id: branch }),
      ...(profile_image && { profile_image }),
    };

    const response = await client.patch(`/users/${userId}`, payload);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanOfficers = async () => {
  try {
    const response = await client.get(`/users?role=Loan Officer&limit=1000`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addUserPermissions = async (id, permissionIds) => {
  try {
    const response = await client.patch(`/users/${id}/permissions/set`, {
      permissionIds: permissionIds,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
